// src/utils.ts
var isPromise = (value) => typeof value?.then === "function";
var runWithMaybePromise = (value, cb) => {
  if (!cb) {
    return value;
  }
  if (isPromise(value)) {
    return value.then((res) => {
      cb(res, true);
      return res;
    });
  } else {
    cb(value, false);
    return value;
  }
};
var runWithMaybeDelay = (cb, maybeTimeCompensation) => {
  if (!cb) {
    return;
  }
  if (maybeTimeCompensation) {
    setTimeout(cb, maybeTimeCompensation);
  } else {
    cb();
  }
};
var generateRandomId = () => Date.now() + Math.random();

// src/manual-span.ts
var ManualSpanRegistryImpl = class {
  constructor(options) {
    this.options = options;
    this.spanMap = /* @__PURE__ */ new Map();
  }
  createSpan(spanOptions, sentryOptionsOrPromise) {
    let resolveSpan;
    let rejectSpan;
    let error;
    const startTime = Date.now();
    let maybeDurationCompensation;
    const maybePromise = runWithMaybePromise(
      sentryOptionsOrPromise,
      ({ sentrySDK, scope }, isPromise2) => {
        if (isPromise2) {
          maybeDurationCompensation = Date.now() - startTime;
        }
        const promise = sentrySDK.startSpan(
          {
            ...spanOptions,
            scope,
            forceTransaction: this.options.forceTransaction
          },
          () => new Promise((resolve, reject) => {
            resolveSpan = resolve;
            rejectSpan = reject;
          })
        );
        promise?.catch((e) => {
          if (e?.message !== error?.message) {
            throw e;
          }
        });
      }
    );
    const endSpan = (cb) => {
      this.spanMap.delete(spanOptions.name);
      runWithMaybePromise(maybePromise, () => {
        runWithMaybeDelay(cb, maybeDurationCompensation);
      });
    };
    const span = {
      end: () => {
        endSpan(() => resolveSpan?.());
      },
      fail: (_error) => {
        error = error ?? _error;
        endSpan(() => rejectSpan?.(_error));
      }
    };
    this.spanMap.set(spanOptions.name, span);
    return span;
  }
  getSpan(spanOptions) {
    return this.spanMap.get(spanOptions.name);
  }
};
var createManualSpanRegistry = (options) => new ManualSpanRegistryImpl(options);
export {
  createManualSpanRegistry,
  generateRandomId,
  isPromise,
  runWithMaybeDelay,
  runWithMaybePromise
};
